module.exports = __webpack_public_path__ + "img/Home_Img2.10a8fbe2.png";